import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

export default class CatSerieService {
  constructor() {
    this.series = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  // Inicializar el servicio
  async initialize() {
    await this.waitForEmpresa();
    await this.listar();
  }

  // Esperar a que la empresa esté disponible
  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50; // 5 segundos máximo
    
    while (!this.selectedEmpresa && attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (!this.selectedEmpresa) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
    }
    
    if (!this.selectedEmpresa) {
      console.warn('Empresa no disponible después de 5 segundos');
    }
  }

  // Listar series
  async listar() {
    this.loading = true;
    this.error = null;

    console.log('Cargando series...');
    
    try {
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.loading = false;
        return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
      }
      const response = await axios.post(getApiUrl('/api/CatSerie/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${authService.getToken()}`,
          'Content-Type': 'application/json'
        }
      });
      
      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allSeries = response.data || [];
      this.series = allSeries.filter(serie => serie.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Series cargados:', this.series.length, 'de', allSeries.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      return {
        success: true,
        data: this.series,
        message: 'Series cargadas exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar series:', error);
      this.error = error?.response?.data?.message || 'No se pudieron cargar las series. Por favor, intente nuevamente.';
      this.loading = false;
      throw error;
    }
  }

  // Guardar serie (insert/update)
  async guardar(serie) {
    try {
      console.log('Guardando serie:', serie);
      
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...serie,
        EmpresaId: selectedEmpresa?.EmpresaId || serie.EmpresaId
      };
      
      const response = await axios.post(getApiUrl('/api/CatSerie/guardar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Recargar la lista después de guardar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: serie.SerieId && serie.SerieId > 0 ? 'Serie actualizada exitosamente' : 'Serie creada exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar serie:', error);
      throw error;
    }
  }

  // Leer una serie específica
  async lectura(clave) {
    try {
      console.log('Leyendo serie:', clave);
      
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatSerie/lectura'), {
        Clave: clave,
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      return {
        success: true,
        data: response.data,
        message: 'Serie encontrada'
      };
    } catch (error) {
      console.error('Error al leer serie:', error);
      throw error;
    }
  }

  // Borrar serie
  async borrar(clave) {
    try {
      console.log('Eliminando serie:', clave);
      
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatSerie/borrar'), {
        Clave: clave,
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Recargar la lista después de eliminar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: 'Serie eliminada exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar serie:', error);
      throw error;
    }
  }

  // Recargar series
  async recargar() {
    console.log('Recargando series...');
    await this.listar();
  }

  // Descarga masiva
  async downloadBulk() {
    try {
      console.log('Descargando series...');
      
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatSerie/descargar'), {
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });
      
      // Crear blob y descargar
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `series_${new Date().toISOString().split('T')[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      return {
        success: true,
        message: 'Descarga iniciada correctamente'
      };
    } catch (error) {
      console.error('Error al descargar series:', error);
      throw error;
    }
  }
}
